import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TimeSlot } from '@checkout/const';
import { DeviceService } from '@shared/services';

@Component({
  selector: 'sd-time-slot-groups-select',
  templateUrl: './time-slot-groups-select.component.html',
  styleUrls: ['./time-slot-groups-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorTimeSlotGroupsSelectComponent {
  @Input() set timeSlots(timeSlots: TimeSlot[]) {
    this.slots = timeSlots;
    this.items = timeSlots.map(({ intervalDisplay }, index) => ({ index, intervalDisplay }));
  }

  @Input() set activeIndex(index: number) {
    this.activeIndexFormControl.patchValue(index);
  }

  @Output() selectTimeSlot = new EventEmitter<TimeSlot>();

  isMobile$ = this.deviceService.isMobileSmDown$;

  activeIndexFormControl = new FormControl(0);

  items: { index: number; intervalDisplay: string }[];
  private slots: TimeSlot[];

  constructor(private deviceService: DeviceService) {}

  setTimeSlot(index: string | number): void {
    this.selectTimeSlot.emit(this.slots[Number(index)]);
  }
}
